.wrap {
  min-width: 0;
}

.row {
  display: flex;
  gap: 2px;
}

.cell {
  display: grid;
  flex: 1 1 0;
  gap: 4px;
  min-width: 0;
}

.segment {
  display: grid;
  place-items: center;
  height: 28px;
  border: 2px solid var(--grade, var(--line-2));
  border-radius: 4px;
  font-size: var(--t-dense);
  font-weight: 700;
  outline: none;
  transition: background var(--dur-1) var(--ease-std);
}

/* The current grade: full fill, the letter in `--on-fill`. */
.on {
  background: var(--grade, var(--line-2));
  color: var(--on-fill);
}

/* Every other grade: an outline and the letter in the grade's own colour, so it reads as "not this
   one" by shape as well as by weight. */
.off {
  background: transparent;
  color: var(--ink-2);
}

.segment:hover,
.segment:focus-visible {
  background: var(--grade, var(--line-2));
  color: var(--on-fill);
}

.segment:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.openable {
  cursor: pointer;
}

.marker {
  display: grid;
  justify-items: center;
  gap: 0;
}

.markerSpace {
  display: block;
  min-height: 1px;
}

/* A triangle under the current grade, drawn with borders so it needs no image. */
.caret {
  width: 0;
  height: 0;
  border-right: 6px solid transparent;
  border-bottom: 7px solid var(--ink);
  border-left: 6px solid transparent;
}

.markerWord {
  color: var(--ink);
  font-size: var(--t-min);
  font-weight: 600;
}

.tipLine {
  display: block;
}

@media (prefers-reduced-motion: reduce) {
  .segment {
    transition: none;
  }
}
